import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoLibroMastroStep2Component } from './conservazione-carica-documento-libro-mastro-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-libro-mastro-step2', {
            url: '/conservazione-carica-libro-mastro',
            ncyBreadcrumb: {
                label: 'Carica Libri Mastro',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-libro-mastro-step2 flex="100"></conservazione-carica-documento-libro-mastro-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoLibroMastroStep2Module: string = ng
    .module('conservazione-carica-documento-libro-mastro-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoLibroMastroStep2', ConservazioneCaricaDocumentoLibroMastroStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-libro-mastro-step2/conservazione-carica-documento-libro-mastro-step2.module.ts